import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AccountLoopBackApiService } from '../services/api/loopback/custom/account.service';

@Injectable()
export class UserAccessGuard implements CanActivate {

  constructor(private router: Router, private staffService: AccountLoopBackApiService) { }

  canActivate() {
    if (this.staffService.isAuthenticated()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/guards/user-access.guard.ts